import React, { useState, useEffect, useCallback } from "react";
import { useMemo, useRef } from "react";
import { Grid, Tooltip } from "@material-ui/core";
import SaveIcon from "@material-ui/icons/Save";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { Link } from 'react-router-dom';
import BiztranControls from "../../biztran_controls/BiztranControls";
import BiztranControlsFormik from "../../biztran_controls_formik/BiztranControlsFormik";
import UseFetchData from "../../../hooks/UseFetchData";
import SearchIcon from "@material-ui/icons/Search";
import { CloseOutlined } from "@material-ui/icons/";
import Button from "../../biztran_controls/Button";

const columns = [
  {
    field: "SalesOrderNo",
    headerName: "SONO",
    headerClassName: "super-app-theme--header",
    headerAlign: "center",
    width: 170,
  },
  {
    field: "ModelCode",
    headerName: "ModelCode",
    headerClassName: "super-app-theme--header",
    headerAlign: "center",
    width: 160,
  },
  {
    field: "ProductName",
    headerName: "Product",
    headerClassName: "super-app-theme--header",
    headerAlign: "center",
    width: 180,
  },
  {
    field: "Description",
    headerName: "Description",
    headerClassName: "super-app-theme--header",
    headerAlign: "center",
    width: 170,
  },
  {
    field: "SOQty",
    headerName: "SOQuantity",
    headerClassName: "super-app-theme--header",
    headerAlign: "center",
    type: "number",
    width: 160,

  },
  {
    field: "BalQty",
    headerName: "SOBalQut",
    headerClassName: "super-app-theme--header",
    headerAlign: "center",
    type: "number",
    width: 150,
  },
  {
    field: "delQut",
    headerName: "DCQuantity",
    headerClassName: "super-app-theme--header",
    headerAlign: "center",
    type: "number",
    width: 160,
    editable: true,
    renderCell: (params) => (
      <Tooltip title={params.row.delQut} >
        <span className="table-cell-trucate">
          {/* {params.row.Quantity != 1 || params.row.Quantity != 0 ? 1 : params.row.Quantity} */}
          {params.row.delQut > 1 ? params.row.delQut : 1}
        </span>
      </Tooltip>
    )
  },

  {
    field: "RATEINRP",
    headerName: "RateINR",
    headerClassName: "super-app-theme--header",
    headerAlign: "center",
    width: 180,
  },
  {
    field: "CgstPer",
    headerName: "Cgst%",
    headerClassName: "super-app-theme--header",
    headerAlign: "center",
    width: 180,
  },
  {
    field: "SgstPer",
    headerName: "Sgst%",
    headerClassName: "super-app-theme--header",
    headerAlign: "center",
    width: 180,
  },
  {
    field: "IgstPer",
    headerName: "Igst%",
    headerClassName: "super-app-theme--header",
    headerAlign: "center",
    width: 180,
  },
];








// function useApiRef() {
//  // debugger;
//   const apiRef = useRef(null);
//   const _columns = useMemo(
//     () =>
//       columns.concat({
//         field: "__HIDDEN__",
//         width: 0,
//         renderCell: (params) => {
//           apiRef.current = params.api;
//           return null;
//         },
//       }),
//     [columns]
//   );
//   return { apiRef, columns: _columns };
// }

// function GetQuantity(params) {
//   var Q = "";
//   return Q;
// }



const AddProduct = (props) => {
  const [selectionModel, setSelectionModel] = React.useState([]);
  const [delQty, setdelQty] = React.useState([]);
  const [cellchanged, setCellchanged] = React.useState([]);
  const [row, setRow] = useState([]);
  const [rows, setRows] = useState([]);
  // const { apiRef, columns } = useApiRef();
  const [editable, seteditable] = useState([]);
  // const [columns, setColumns] = useState([]);
  // const [SalesOrderNo, setSalesOrderNo] = useState("");
  const [StateName, setStateName] = useState("");
  const [StateResponse, fetchState] = UseFetchData();
  const [CurrencyID, setCurrencyID] = useState("");
  const [AccountID, setAccountID] = useState({ id: props.AccountID });
  const [SalesOrderNo, setSalesOrderNo] = useState(props.SalesOrderNo);
  const [AccName, setAccName] = useState("");
  const [Accountcmb, setAccountcmb] = useState([]);
  const [AccountName, setAccountName] = useState({ id: props.AccountID, AccountName: props.AccountName });
  const [ComboDataResponse, fetchComboData] = UseFetchData();
  const [response, fetchData] = UseFetchData();
  const [BalQty, setBalQty] = useState("");
  const [ModelCode, setModelCode] = useState("");
  const [id, setid] = useState("");
  const [Description, setDescription] = useState("");
  const [ConversionResopnse, fetchConversion] = UseFetchData();
  const [ConversionRate, setConversionRate] = useState("");
  const [ProductListresponse, FetchProductListData] = UseFetchData();
  const [responseCust, fetchAccountData] = UseFetchData();
  const [ACAccount, setACAccount] = useState([]);
  const [ProductGroupcmb, setProductGroupcmb] = useState([]);
  const [ProductCat1cmb, setProductCat1cmb] = useState([]);
  const [ProductCat2cmb, setProductCat2cmb] = useState([]);
  const [ProductCat3cmb, setProductCat3cmb] = useState([]);
  const [ProductCat4cmb, setProductCat4cmb] = useState([]);
  const [ProductGroupID, setProductGroupID] = useState("");
  const [ProductCat1ID, setProductCat1ID] = useState("");
  const [ProductCat2ID, setProductCat2ID] = useState("");
  const [ProductCat3ID, setProductCat3ID] = useState("");
  const [ProductCat4ID, setProductCat4ID] = useState("");



  useEffect(() => {
    // debugger;
    setRows(ProductListresponse);
  }, [ProductListresponse]);

  useEffect(() => {
    // debugger;
    if (props.DCDtlsData != null && props.DCDtlsData.length > 0) {
      setRow(props.DCDtlsData);
    }
  }, [props.DCDtlsData]);

  const validationSchema = Yup.object({
  });





  const AccountData = React.useCallback((options) => {
    if (options !== undefined) {
      let Account = options.map((data) => (
        <option key={data.AccountName} value={data.AccountID}>
          {data.AccountName}
        </option>
      ));
      setAccountcmb(Account);
    }
  }, []);

  useEffect(() => {
    if (ComboDataResponse !== undefined) {
      if (ComboDataResponse["ProductGroup"] !== undefined) {
        ProductGroupData(ComboDataResponse["ProductGroup"]);
      }
      if (ComboDataResponse["Account"] !== undefined) {
        AccountData(ComboDataResponse["Account"]);
      }
    }
  }, [ComboDataResponse]);

  useEffect(() => {
    GetComboData();
  }, [ProductCat1ID, ProductCat2ID, ProductCat3ID]);




  useEffect(() => {
    debugger;
    if (response.Response === true) {
      alert(response.Message);
      setProductGroupID("");
      setAccountID("");
      // props.setOpen(false);
      props.getByIDData();
      PopulateData();
    } else if (response.Response === false) {
      if (response.Message.includes("Already") === true) {
        alert(response.Message);
      } else {
        alert("Failed.");
      }
    }
  }, [response]);


  const ProductGroupData = (options) => {
    if (options !== undefined) {
      let ProductGroup = options.map((data) => (
        <option key={data.ProductGroup} value={data.ProductGroupID}>
          {data.ProductGroup}
        </option>
      ));
      setProductGroupcmb(ProductGroup);
    }
  };


  useEffect(() => {
    // debugger;
    if (StateResponse !== undefined) {
      if (StateResponse["StateData"] !== undefined) {
        // debugger;
        setStateName(StateResponse["StateData"][0]["StateName"]);
        // debugger;
      }
    }
  }, [StateResponse]);

  // useEffect(() => {
  //   if (responseCust['cmbAccount'] !== undefined && responseCust['cmbAccount'].length > 0) {
  //     setACAccount(responseCust['cmbAccount']);
  //   }
  // }, [responseCust['cmbAccount']])

  useEffect(() => {
    // debugger;
    if (ConversionResopnse !== undefined) {
      if (ConversionResopnse["ConversionData"] !== undefined) {
        // debugger;
        setConversionRate(ConversionResopnse["ConversionData"][0]["ConversionRate"]);
        setCurrencyID(ConversionResopnse["ConversionData"][0]["CurrencyID"]);
      }
    }
  }, [ConversionResopnse]);

  const GetStateDate = () => {
    var bodyFormData = new FormData();
    bodyFormData.append("DeliveryChallanID", props.DCID);
    fetchState("DeliveryChallan/StateData", bodyFormData);
  }

  const GetConversionDate = () => {
    var bodyFormData = new FormData();
    bodyFormData.append("DeliveryChallanID", props.DCID);
    fetchConversion("DeliveryChallan/ConversionData", bodyFormData);
  }


  const GetComboData = () => {
    var bodyFormData = new FormData();
    bodyFormData.append("AccountID", AccountID);
    fetchComboData("DeliveryChallan/ComboDataAddPro", bodyFormData);
  };

  useEffect(() => {
    GetComboData();
    GetStateDate();
    GetConversionDate();
  }, []);




  const onSelectChange = (e) => {
    // debugger;
    let targetvalue = e.target.value;
    let targetname = e.target.name;
    if (targetvalue !== "") {
      if (targetname === "AccountID") {
        setAccountID(targetvalue);
      }
      if (targetname === "ProductGroupID") {
        setProductGroupID(targetvalue);
        // setProductCat1ID("");
        // setProductCat2ID("");
        // setProductCat3ID("");
        // setProductCat4ID("");
        // setProductCat1cmb([]);
        // setProductCat2cmb([]);
        // setProductCat3cmb([]);
        // setProductCat4cmb([]);
      }
    }
    else {
      if (targetname === "AccountID") {
        setAccountID("");
      }
      if (targetname === "ProductGroupID") {
        setProductGroupID("");
        // setProductCat1ID("");
        // setProductCat2ID("");
        // setProductCat3ID("");
        // setProductCat4ID("");
        // setProductCat2cmb([])
        // setProductCat3cmb([])
        // setProductCat4cmb([])
      }

    }
  };


  const handleCellEditCommit = React.useCallback(
    ({ id, field, value }) => {
      setCellchanged(value)
      // debugger;

      if (field === "delQut") {
        const [Quantity] = value.toString().split(" ");
        const updatedRows = rows.map((rows) => {
          if (rows.id === id) {
            return { ...rows, Quantity };
          }
          return rows;
        });
        setRows(updatedRows);
        SaveData(updatedRows);
      }

    },
    [rows]
  );

  const SaveData = (value) => {
    debugger;
    try {
      let Seq = 0;
      for (var i = 0; i < value.length; i++) {
        if (value[i].Quantity != '' && value[i].Quantity != null) {
          Seq += 1;
          {
            const Qty = parseInt(value[i].Quantity);
            if (Qty > value[i].BalQty) {
              alert("Enter Qtn is More Then Bal ..");
            }
            else {
              var bodyFormData = new FormData();
              bodyFormData.append("DeliveryChallanDtlsID", props.DeliveryChallanDtlsID);
              bodyFormData.append("DeliveryChallanID", props.DCID);
              bodyFormData.append("SalesOrderDtlsID", value[i].id);
              bodyFormData.append("ProductSKUID", value[i].ProductSKUID);
              bodyFormData.append("Seq", Seq);
              bodyFormData.append("Description", value[i].Description);
              // bodyFormData.append("StateName", StateName);
              bodyFormData.append("CurrencyID", CurrencyID);
              bodyFormData.append("ConvFactor", ConversionRate);
              bodyFormData.append("Quantity", value[i].Quantity);
              bodyFormData.append("Rate", value[i].RATES);
              bodyFormData.append("RateINR", value[i].RATEINRP);
              bodyFormData.append("CgstPer", value[i].CgstPer);
              bodyFormData.append("SgstPer", value[i].SgstPer);
              bodyFormData.append("IgstPer", value[i].IgstPer);
              bodyFormData.append("SalesOrderNo", SalesOrderNo);
              bodyFormData.append("TotalAmount", value[i].Quantity * value[i].RATES);
              bodyFormData.append("TotalAmountINR", value[i].Quantity * value[i].RATEINRP);
              fetchData("DeliveryChallan/AddProduct", bodyFormData);
            }
          }
        }
      }
      // props.setOpen(false);
      // props.getByIDData();
    }
    catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    PopulateData();
  }, []);

  const PopulateData = () => {
    // debugger;
    var bodyFormData = new FormData();
    bodyFormData.append("DeliveryChallanDtlsID", props.DeliveryChallanDtlsID);
    bodyFormData.append("AccountID", props.AccountID);
    bodyFormData.append("SalesOrderDtlsID", id);
    // bodyFormData.append("SalesOrderNo", SalesOrderNo);
    FetchProductListData("DeliveryChallan/ProductList", bodyFormData);
  };


  return (
    <Grid xs={12}>
      <Formik
        initialValues={{}}
        validationSchema={validationSchema}
        // onSubmit={onSubmit}
        enableReinitialize
      >
        {(formik) => {
          return (
            <Form>
              <Grid spacing={2} container direction="row" xs={12}>
                <Grid item xs={1}>
                  <label
                    htmlFor={"AccountID"}
                    style={{
                      display: "block",
                      width: "100%",
                    }}
                  >
                    {"Customer"}
                  </label>
                </Grid>
                <Grid item xs={4}>
                  <BiztranControlsFormik
                    control="select"
                    name="id"
                    value={props.AccountID}
                    options={Accountcmb}
                    onChange={onSelectChange}
                    disabled={true}
                  />
                </Grid>

              </Grid>
              <Grid spacing={2} container direction="row">
                <Grid xs={12}>
                  <BiztranControls.DataGrid
                    rowHeight={25}
                    rows={rows}
                    columns={columns}
                    experimentalFeatures={{ editable: true }}
                    // checkboxSelection
                    // disableSelectionOnClick
                    // onSelectionModelChange={(newSelection) => {
                    //   setSelectionModel(newSelection);
                    // }}
                    // rows={this.state.rows}
                    // rowGetter={this.rowGetter}
                    onCellEditCommit={handleCellEditCommit}
                    Height="340px"
                    Width="100%"
                  />
                </Grid>

                {/* <Grid item xs={3} container direction="row">
                  <h5 style={{ width: 110 }}>Selected Item:{ }</h5>
                </Grid> */}
                <Grid xs={12} style={{ marginTop: 7 }}>
                  <div style={{ width: "100%" }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignContent: "center",
                      }}
                    >
                      {/* <BiztranControls.Button
                        text="Add"
                        startIcon={<SaveIcon />}
                        style={{ marginTop: "0%" }}
                        onClick={() => {
                          onSubmit();
                        }}
                      /> */}
                      <BiztranControls.Button
                        text="Close"
                        startIcon={<CloseOutlined />}
                        style={{ marginTop: "0%" }}
                        onClick={() => props.setOpen(false)}
                      />
                    </div>
                  </div>
                </Grid>
              </Grid>
            </Form>
          );
        }}
      </Formik>
    </Grid>
  );
};

export default AddProduct;

